var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _mask, _path3, _mask2, _path4, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 398,
    viewBox: "0 0 398 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 199,
    fill: "#2D2D2D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 184.5,
    stroke: "#494949"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 171.5,
    stroke: "#494949"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 158.5,
    stroke: "#494949"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 145.5,
    stroke: "#494949"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 132.5,
    stroke: "#494949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 199C118 154.265 154.265 118 199 118V118C243.735 118 280 154.265 280 199V199H118V199Z",
    fill: "#5738D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 199C118 243.735 154.265 280 199 280V280C243.735 280 280 243.735 280 199V199H118V199Z",
    fill: "#9382DB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_43_18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 199C129 237.66 160.34 269 199 269V269C237.66 269 269 237.66 269 199V199H129V199Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122 199C122 241.526 156.474 276 199 276C241.526 276 276 241.526 276 199H262C262 233.794 233.794 262 199 262C164.206 262 136 233.794 136 199H122ZM269 199H129H269ZM122 199C122 241.526 156.474 276 199 276V262C164.206 262 136 233.794 136 199H122ZM199 276C241.526 276 276 241.526 276 199H262C262 233.794 233.794 262 199 262V276Z",
    fill: "#5738D2",
    mask: "url(#path-9-inside-1_43_18)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-2_43_18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129 199C129 160.34 160.34 129 199 129V129C237.66 129 269 160.34 269 199V199H129V199Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122 199C122 156.474 156.474 122 199 122C241.526 122 276 156.474 276 199H262C262 164.206 233.794 136 199 136C164.206 136 136 164.206 136 199H122ZM269 199H129H269ZM122 199C122 156.474 156.474 122 199 122V136C164.206 136 136 164.206 136 199H122ZM199 122C241.526 122 276 156.474 276 199H262C262 164.206 233.794 136 199 136V122Z",
    fill: "#9382DB",
    mask: "url(#path-11-inside-2_43_18)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 199,
    r: 6,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.9736ff05233428f48358c3e79a331475.svg";
export { ForwardRef as ReactComponent };